import React, {useState, useEffect, useCallback, useRef} from 'react'
import {Input,  Image, message, Button, Space} from 'antd'
import {CloseOutlined} from '@ant-design/icons'
import DraggableModal from "../../components/DraggableModal";
import PicUploader, {PDFUploader} from "../../components/Uploader";
import JobFairApi from "../../api/jobfair";

export default function SchoolModal({onClose,onRemove, isShow, data}) {
    const [isOpen, setIsOpen] = useState(false)
    const [schoolName, setSchoolName] = useState()
    const [studentNumber, setStudentNumber] = useState()
    const [lectureTime, setLectureTime] = useState()
    const [hireTime, setHireTime] = useState()
    const [address, setAddress] = useState()
    const [downloadLink, setDownloadLink] = useState()
    const [coverImg, setCoverImg] = useState()
    const [sort, setSort] = useState(0)



    const [loading, setLoading] = useState(false)


    useEffect(() => {
        if (isShow) {
            if (!!data.id) {
                setSchoolName(data.schoolName)
                setStudentNumber(data.studentNumber)
                setLectureTime(data.lectureTime)
                setHireTime(data.hireTime)
                setAddress(data.address)
                setDownloadLink(data.downloadLink)
                setCoverImg(data.coverImg)
                setSort(data.sort)
            }
        } else {
            setSchoolName()
            setStudentNumber()
            setLectureTime()
            setHireTime()
            setAddress()
            setDownloadLink()
            setCoverImg()
            setSort(0)
        }
        setIsOpen(isShow)
    }, [isShow])

    const onFileUploader = useCallback(url => {
        setDownloadLink(url)
    })

    const onCoverImg = useCallback((url)=>{
        setCoverImg(url)
    })

    const save = useCallback(() => {
        JobFairApi.addJobFairSchool({
            id: data.id,
            jobFairId: data.jobFairId,
            jobFairLabelId: data.jobFairLabelId,
            schoolName,
            studentNumber,
            lectureTime,
            hireTime,
            address,
            coverImg,
            downloadLink,
            sort
        }).then(resp=>{
            if (resp.resultCode === 1) {
                message.success(resp.resultMessage)
                onClose({
                    id: data.id || resp.info,
                    jobFairId: data.jobFairId,
                    jobFairLabelId: data.jobFairLabelId,
                    schoolName,
                    studentNumber,
                    lectureTime,
                    hireTime,
                    address,
                    coverImg,
                    downloadLink,
                    sort
                })
            }
        })
    })


    return (
        <DraggableModal
            title="添加大学"
            open={isOpen}
            onOk={save}
            onCancel={() => onClose()}
            width={800}
            okText="保存"
            footer={null}
            maskClosable={false}
        >
            <div className="white-bg mgt32 pdb40 pdh32">
                <div className="flexbox">
                    <div>
                        <div className="gray-dark mgb8">大学名称</div>
                        <Input
                            style={{width: 280}}
                            value={schoolName}
                            placeholder="请填写"
                            maxLength={120}
                            onChange={(e) => setSchoolName(e.target.value)}/>
                    </div>
                    <div className="mgl40">
                        <div className="gray-dark mgb8">毕业生人数</div>
                        <Input
                        style={{width: 280}}
                        value={studentNumber}
                        placeholder="请填写人数"
                        maxLength={120}
                        onChange={(e) => setStudentNumber(e.target.value)}/>
                    </div>
                </div>

                <div className="flexbox mgt28">
                    <div>
                        <div className="gray-dark mgb8">宣讲时间（选填）</div>
                        <Input
                            style={{width: 280}}
                            value={lectureTime}
                            placeholder="请填写"
                            maxLength={120}
                            onChange={(e) => setLectureTime(e.target.value)}/>
                    </div>
                    <div className="mgl40">
                        <div className="gray-dark mgb8">招聘时间</div>
                        <Input
                            style={{width: 280}}
                            value={hireTime}
                            placeholder="请填写"
                            maxLength={120}
                            onChange={(e) => setHireTime(e.target.value)}/>
                    </div>
                </div>

                <div className="mgt28">
                    <div className="gray-dark mgb8">地理位置</div>
                    <Input
                        style={{width: 600}}
                        value={address}
                        placeholder="请填写"
                        maxLength={200}
                        onChange={(e) => setAddress(e.target.value)}/>
                </div>

                <div className="gray-dark mgt32 mgb8">封面</div>
                <PicUploader type={4} onResult={onCoverImg}>
                    {coverImg && <Image src={coverImg} preview={false} style={{width: 102, height: 102}}/>}
                    {!coverImg && <div className="gray text-center">
                        <div className="fts-32 gray-light">+</div>
                        <div className="gray-light fts-13">建议尺寸696*388px</div>
                    </div>}
                </PicUploader>

                <div className="mgt12">生源表</div>
                <div className="mgt8">
                    <PDFUploader type="xiaozhao" onResult={onFileUploader}/>
                    {downloadLink && <span className="blue mgl40">2025年生源表.pdf</span>}
                </div>
                <div className="gray-light fts-13 mgt6">支持pdf格式</div>
            </div>
            <div className="flexbox justifyCenter mgt24">
                <Space>
                    <Button key="submit" type="primary" loading={loading} onClick={save}>
                        保存
                    </Button>
                    <Button key="cancel" onClick={()=>onClose()}>
                        取消
                    </Button>
                </Space>
            </div>
        </DraggableModal>)
}




